import "@mercdev.com/mercurial-ui/dist/style.css";
import "@mercdev.com/mercurial-ui/src/common/reset.css";
import "@mercdev.com/mercurial-ui/src/common/fonts.css";
import "./index.scss";

import { ThemeProvider } from "@mercdev.com/mercurial-ui/branding";
import { AccessGate } from "@mercdev.com/mercurial-ui/display";
import { OAuth2Provider, Service } from "@mercdev.com/mercury-id-authorization";
import ReactDOM from "react-dom/client";

import { Root } from "./app";
import { StayTuned } from "./screens/access/StayTuned";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <OAuth2Provider
    config={{
      clientId: import.meta.env.VITE_MERCURY_CLIENT_ID,
      redirectUri: `${import.meta.env.VITE_CLIENT_URL}/callback`,
      env: import.meta.env.VITE_MERCURY_ENV,
      apiBaseUrl: import.meta.env.VITE_SHORTENER_API_URL,
      postLoginRedirect: "/",
      service: Service.Shortener,
      debug: import.meta.env.VITE_MODE === "local",
    }}
    enforceAccess
    loadingComponent={<AccessGate variant="loading" />}
    accessDeniedComponent={<StayTuned />}
    noPortalComponent={<StayTuned />}
    errorComponent={<StayTuned />}
  >
    <ThemeProvider>
      <Root />
    </ThemeProvider>
  </OAuth2Provider>
);
